import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import styles from './index.module.scss';
interface Props {
  name: string;
  url: string;
  handleClick: () => void;
}
export const UserName = t0 => {
  const $ = _c(5);
  const {
    name,
    url,
    handleClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classnames("headline-6", styles.name);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== handleClick || $[2] !== name || $[3] !== url) {
    t2 = <h6 className={t1}><a href={url} onClick={handleClick}>{name}</a></h6>;
    $[1] = handleClick;
    $[2] = name;
    $[3] = url;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};